export const style = {
    box: { 
        display: 'flex', 
        justifyContent: 'center', 
        paddingBottom: 30 
    }
}